import { ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit } from '@angular/core'
import { ConfigurationService } from '@spartacus/core'
import { CmsComponentData } from '@spartacus/storefront'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { combineLatest, Observable, Subscription } from 'rxjs'
import { map } from 'rxjs/operators'
import { EbUserInterface } from '../../../../user/interface/eb-user.interface'
import { EbContactCardCmsInterface } from '../../interface/eb-contact-card-cms.interface'

@Component({
    selector: 'eb-contact-card',
    templateUrl: './eb-contact-card.component.html',
    styleUrls: ['./eb-contact-card.component.scss'],
    standalone: false
})
export class EbContactCardComponent implements OnInit, OnDestroy {
  constructor(
    protected componentData: CmsComponentData<EbContactCardCmsInterface>,
    protected user: UserAccountFacade,
    protected config: ConfigurationService,
    protected cd: ChangeDetectorRef
  ) {}

  get partner$() {
    return combineLatest([this.user.get(), this.componentData.data$, this.getBaseUrl$()]).pipe(
      map(([user, componentData, baseUrl]) => {
        const partners = (user as EbUserInterface)?.partners || []
        return partners.find(partner => partner.partnerFunction === componentData.partnerFunction)
      })
    )
  }

  @HostBinding('class.has-partner-data') hasPartnerData = false

  subscriptions = new Subscription()

  ngOnInit() {
    this.subscriptions.add(
      this.partner$.subscribe(partner => {
        this.hasPartnerData = !!partner
        this.cd.detectChanges()
      })
    )
  }

  private getBaseUrl$(): Observable<string> {
    return this.config.unifiedConfig$.pipe(
      map(config => {
        return config.backend?.media?.baseUrl ?? config.backend?.occ?.baseUrl
      })
    )
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }
}
